import { render, staticRenderFns } from "./accessRequest.vue?vue&type=template&id=fba1767a&scoped=true&"
import script from "./accessRequest.vue?vue&type=script&lang=ts&"
export * from "./accessRequest.vue?vue&type=script&lang=ts&"
import style0 from "./accessRequest.vue?vue&type=style&index=0&id=fba1767a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba1767a",
  null
  
)

export default component.exports